import React, { useCallback, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { useLivePoll } from "../lib/live";

export default function Productivity() {
  const [data, setData] = useState({ deliverers: [], period_days: 30 });

  const load = useCallback(async () => {
    const { data: d } = await api.get("/productivity?days=30");
    setData(d);
  }, []);

  useLivePoll(load, 30000);

  return (
    <div className="space-y-6" data-testid="productivity-page">
      <div>
        <h1 className="font-display font-bold text-2xl">Produtividade individual</h1>
        <p className="text-sm text-muted-foreground">Últimos {data.period_days} dias</p>
      </div>
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {(data.deliverers || []).map((d, i) => (
          <Card key={d.deliverer_id} className="p-4">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-semibold">{d.name}</div>
                <div className="text-xs text-muted-foreground">#{i + 1} no ranking</div>
              </div>
              <div className="text-2xl font-display font-bold text-[var(--brand)]">{d.success_rate}%</div>
            </div>
            <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs">
              <div><div className="font-bold text-lg">{d.delivered}</div>entregues</div>
              <div><div className="font-bold text-lg">{d.attempted}</div>tentativas</div>
              <div><div className="font-bold text-lg">R$ {d.commission_total?.toFixed(2)}</div>comissões</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
